import DatabaseModel from './DatabaseModel.js';

var RegistroEmail = Object.create(DatabaseModel);

RegistroEmail.model = 'core/registroemail';
RegistroEmail.modelFront = 'registroemail';

export default RegistroEmail;